export const STORAGE_TYPE = Object.freeze({
  DataverseOnly: 'DataverseOnly',
  DataverseAndSql: 'DataverseAndSql',
});
